import {Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges} from '@angular/core';
import { Contract } from 'src/app/snatch/models/contract.model';
import {ProductVideo} from "../../models/product-media.model";

@Component({
  selector: 'leap-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.less', '../../styles/tab-content.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AboutComponent implements OnChanges{

  @Input() longDescription: string;
  @Input() sellerRole: string;
  @Input() sellerAccreditationStatus: string;
  @Input() trainerRequirements: string;
  @Input() ipStatement: string;
  @Input() video: ProductVideo;

  @Input() segmentsMapper: Map<string, Contract>;
  @Input() restricted: boolean;
  @Input() hasAccess: boolean;

  constructor() {
  }
  ngOnChanges(){
  }
}
